module.exports = __webpack_public_path__ + "img/thumbnail-marquee-img-calyrafit.404cca03.webp";